import { productState } from './product.state';
import { productActions } from './product.action';
import { productMutations } from './product.mutation';

export default {
  namespaced: true,
  state: productState,
  getters: {},
  actions: productActions,
  mutations: productMutations,
};
